import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const RideFeedbacksCountWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-feedbacks-count-wrapper",
})`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;

  .feedback-count-icon-container {
    display: flex;
    align-items: center;
    margin-inline-end: 5px;

    &.should-hide-icon {
      display: none;
    }
  }

  &.is-compact .feedback-count-icon-container {
    margin-inline-end: 4px;
  }

  .feedbacks-count-label {
    font-weight: 800;
    font-size: 14px;

    &.blueColor {
      color: ${rydeColors.darkBlue};
    }
  }

  &.is-compact .feedbacks-count-label {
    font-weight: 500;
    font-size: 12px;
  }

  .seats-count-by-driver-label {
    font-weight: 800;
    font-size: 14px;
    color: ${rydeColors.darkBlue};
  }
`;

export const FeedbackCountDropdownSelect = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "feedback-count-dropdown-select-wrapper",
})`
  inset-inline-start: 0;
  display: inline-flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  border: 1px solid ${greyMui._300};
  background-color: ${rydeColors.smoke};
  z-index: ${ScreenDepth.LANG_SWITCH_PANEL};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  min-width: 100%;

  .feedback-count-option-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 35px;
    white-space: nowrap;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;

    &:hover {
      transform: scale(1.02);
      border-bottom: 0.5px solid ${greyMui._300};
    }

    &.disabled {
      cursor: default;
      color: ${greyMui._500};
      pointer-events: none;
    }
  }
`;
